
import React from 'react';
import { UCAModule, CommonModule, isFeatureFlagEnabled } from "uca-react-containers-library";
import Loader from './loader';

const LoyaltyPartnersV4Component = () => {
    const {isLoading } = CommonModule.useAuth();
    const { saveRouteData } = CommonModule.useRoute();
    const isAtmosRewardsEnabled = isFeatureFlagEnabled('enableAtmosRewardsLoyaltyPartners');

    React.useEffect(() => {
        saveRouteData({ 'currentPage': 'Loyalty Partners' });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const renderLoyaltyPartners = () =>
        isAtmosRewardsEnabled
            ? <UCAModule.LoyaltyPartnersV4></UCAModule.LoyaltyPartnersV4>
            : <UCAModule.LoyaltyPartnersV3></UCAModule.LoyaltyPartnersV3>;

    if (isLoading) return <Loader></Loader>;

    return (
        <CommonModule.ViewportProvider>
            <div className="col-lg-3 col-xl-3">
                <UCAModule.LeftNavigation></UCAModule.LeftNavigation>
            </div>
            <div className="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-9">
                {renderLoyaltyPartners()}
            </div>
        </CommonModule.ViewportProvider>
    );
};

export default LoyaltyPartnersV4Component;
